{
	"showButtonTitle": "Εμφάνιση",
	"hideButtonTitle": "Απόκρυψη"
}
